import { compose, setStatic } from 'core/libs/recompose';

import resolve from './resolve';

/**
 * Так как `Symbol` еще не везде доступен используем обычную ссылку на объект для подписи компонента.
 */
export const signature = {};

/**
 * Используем этот дата-резолвер для создания новой ветки резолвинга данных.
 * Это поможет не испортить маппинг данных при пропуске резолвинга ветки
 * виртуального дерева.
 */
const resolutionBreakpointProvider = resolve('$', () => 0);

export default function skipHOC(Component) {
  return compose(
    resolutionBreakpointProvider,
    setStatic('signature', signature),
  )(Component);
}
